import { render, staticRenderFns } from "./FormularioPoligono.vue?vue&type=template&id=5e6eef93&"
import script from "./FormularioPoligono.vue?vue&type=script&lang=js&"
export * from "./FormularioPoligono.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports